import React from 'react';
import HubErrorPage from '../components/common/HubErrorPage';

function UnauthorizedPage() {
  return (
    <HubErrorPage
      type="forbidden"
      variant="standalone"
      secondaryAction={{ to: '/login', labelKey: 'errors.loginDifferentAccount' }}
    />
  );
}

export default UnauthorizedPage;
